<template>
  <div class="pop" v-if="value">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ToolTip',
  props:{
    value:{
      type:Boolean,
      default:true
    }
  }
}
</script>

<style lang="scss" scoped>
/*气泡*/
.pop {
  position:relative;
  height:30px;
  line-height: 30px;
  color:#fff;
  vertical-align: middle;
  font-size: 12px;
  border-radius:5px; /* 圆角 */
  background-color: #4D4948;
  border:1px solid #4D4948;
  text-align: center;
  padding: 0 10px;
}
</style>
